import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default new Router({
	mode: 'history',
	routes: [
		{
			//首页
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			//首页
			path: '/aboutUs',
			name: 'aboutUs',
			component: (resolve) => require(['@/views/aboutUs.vue'], resolve),
		},
		{
			//首页
			path: '/services',
			name: 'services',
			component: (resolve) => require(['@/views/services.vue'], resolve),
		},
		{
			//首页
			path: '/projects',
			name: 'projects',
			component: (resolve) => require(['@/views/projects.vue'], resolve),
		},
		//cooperate
	],
})
